module.exports = __webpack_public_path__ + "img/vn_vn.14e168aa.png";